import styled from 'styled-components';
import { HeadingExtraBoldS } from '../../styles/globals';
import Icon from '@/assets/icons/infogrey.svg?react';

export const ActionCardButton = styled.button`
  ${({ theme }) => `
    display: flex;
    width: 100%;
    height: 80px;
    margin: 0;
    padding: ${theme.layout.spacing.mili} ${theme.layout.spacing.decy};
    align-items: center;
    align-self: stretch;
    gap: 8px;
    background: ${theme.colors.neutral.primary[0]};
    border: none;
    cursor: pointer;
    transition: background 0.2s esae-in-out;

    &:hover {
      background: ${theme.colors.primary[10]};
    }

    @media (${theme.layout.breakpoints.max.tablet}) {
      height: auto;
      padding: ${theme.layout.spacing.mili};
      flex-flow: column nowrap;
    };
  `};
`;

export const InfoIcon = styled(Icon)`
  ${({ theme }) => `
    width: 48px;
    height: 48px;
    padding: ${theme.layout.spacing.mikro};

    path {
      fill: ${theme.colors.neutral.primary[60]};
    }

    @media (${theme.layout.breakpoints.max.tablet}) {
      width: 32px;
      height: 32px;
    }
  `};
`;

export const ContentCont = styled.span`
  ${({ theme }) => `
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex: 1;
    gap: 8px;

    @media (${theme.layout.breakpoints.max.tablet}) {
      width: 100%;
    }
  `};
`;

export const Title = styled(HeadingExtraBoldS)`
  text-align: left;

  ${({ theme }) => `
    @media (${theme.layout.breakpoints.max.tablet}) {
      font-size: 16px;
      line-height: 19px;
    }
  `};
`;

export const Score = styled(HeadingExtraBoldS)`
  ${({ theme }) => `
    width: 100px;
    padding: 0 ${theme.layout.spacing.mili};
    color: ${theme.colors.neutral.primary[60]};
    
    @media (${theme.layout.breakpoints.max.tablet}) {
      width: auto;
      padding: 0;
      font-size: 16px;
      line-height: 19px;
    }
  `};
`;

export const ProgressCont = styled.span`
  ${({ theme }) => `
    display: flex;
    max-width: 512px;
    width: 100%;
    flex-flow: column nowrap;

    @media (${theme.layout.breakpoints.max.tablet}) {
      max-width: 100%;
    }
  `};
`;
